import { createValueAccessor } from "@mrocket/utils";
import { Sizes } from "../types";

type SizeType = Sizes & {none?: string}

export const getSize = createValueAccessor<SizeType>